// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"a9f6dd65","392":"994b0b37","476":"994b0b37"}[chunkId] + ".chunk.css";
};